import { injectable } from 'inversify';
import { FluoroAnglesCalculator } from './FluoroAnglesCalculator';
import type {
  IFluoroAnglesCalculator,
  IFluoroAnglesCalculatorFactory,
  IFluoroAnglesIntegrationApi
} from './interfaces';

@injectable()
export class FluoroAnglesCalculatorFactory implements IFluoroAnglesCalculatorFactory {
  public createController(api: IFluoroAnglesIntegrationApi): IFluoroAnglesCalculator {
    return new FluoroAnglesCalculator(api);
  }
}
